class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay')) || 5000; // Default 5 seconds
        this.expiresDate = parseInt(this.popup.getAttribute('data-expire')) || 30; // Default 30 days
        
        // Wait for DOM to be fully loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initializePopup());
        } else {
            this.initializePopup();
        }
    }

    initializePopup() {
        // Only show popup if:
        // 1. User is not logged in
        // 2. We're on the homepage
        // 3. Newsletter popup cookie doesn't exist
        if (!this.isUserLoggedIn() && this.isHomePage() && this.getCookie('newsletter-popup') === '') {
            var popup = this.popup;

            setTimeout(function() {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700)
        }
        
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        const closeButton = this.querySelector('[data-close-newsletter-popup]');
        if (closeButton) {
            closeButton.addEventListener('click', this.setClosePopup.bind(this));
        }

        const form = this.querySelector('#ContactPopup');
        if (form) {
            form.addEventListener('submit', this.setClosePopup.bind(this));
        }

        // Add event listener for "Don't show again" checkbox
        const dismissCheckbox = this.querySelector('#dismiss');
        if (dismissCheckbox) {
            dismissCheckbox.addEventListener('change', (event) => {
                if (event.target.checked) {
                    // If checked, set a very long expiration (e.g., 10 years)
                    this.setCookie('newsletter-popup', 'closed', 3650);
                }
            });
        }
    }

    isUserLoggedIn() {
        try {
            // Check multiple possible indicators of logged-in state
            const indicators = [
                '.customer-account-link',
                '.customer-login-link',
                '[data-customer-account]',
                '[data-customer-login]'
            ];
            
            return indicators.some(selector => document.querySelector(selector) !== null);
        } catch (error) {
            console.error('Error checking login status:', error);
            return false; // Fail safe: assume not logged in if there's an error
        }
    }

    isHomePage() {
        try {
            const path = window.location.pathname;
            return path === '/' || path === '/index' || path === '/index.html';
        } catch (error) {
            console.error('Error checking homepage status:', error);
            return false; // Fail safe: assume not homepage if there's an error
        }
    }

    setCookie(cname, cvalue, exdays) {
        try {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax';
        } catch (error) {
            console.error('Error setting cookie:', error);
        }
    }

    getCookie(cname) {
        try {
            const name = cname + '=';
            const ca = document.cookie.split(';');

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        } catch (error) {
            console.error('Error getting cookie:', error);
            return ''; // Fail safe: return empty string if there's an error
        }
    }

    deleteCookie(name) {
        try {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;SameSite=Lax';
        } catch (error) {
            console.error('Error deleting cookie:', error);
        }
    }

    setClosePopup() {
        try {
            // If "Don't show again" is checked, use a very long expiration
            const dismissCheckbox = this.querySelector('#dismiss');
            const expirationDays = dismissCheckbox && dismissCheckbox.checked ? 3650 : this.expiresDate;
            
            this.setCookie('newsletter-popup', 'closed', expirationDays);
            document.body.classList.remove('newsletter-show');
            setTimeout(() => {
                document.body.classList.remove('show-newsletter-image');
            }, 700);
        } catch (error) {
            console.error('Error closing popup:', error);
            // Still try to remove classes even if there's an error
            document.body.classList.remove('newsletter-show', 'show-newsletter-image');
        }
    }

    onBodyClickEvent(event) {
        try {
            if (!this.contains(event.target)) {
                this.setClosePopup();
            }
        } catch (error) {
            console.error('Error handling body click:', error);
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);